import React from 'react';
import PropTypes from 'prop-types';

import themeable from 'zignal-landscape/lib/themeable';


const LayoutApp = ({styles, children}) => {
  return (
    <div className={styles.default}>{children}</div>
  );
};

LayoutApp.propTypes = {
  styles: PropTypes.object,
  children: PropTypes.node
};

LayoutApp.displayName = 'LayoutApp';

export default themeable(LayoutApp);
